export const STAT_SCOPE_OPTIONS = [
	{ code: 'US', name: 'United States', flag: '🇺🇸', regionsLabel: 'US regions' },
	{ code: 'CAN', name: 'Canada', flag: '🇨🇦', regionsLabel: 'Canadian provinces' },
	{ code: 'MX', name: 'Mexico', flag: '🇲🇽', regionsLabel: 'Mexican states' },
	{ code: 'COMBINED', name: 'North America', flag: '🌎', regionsLabel: 'North American regions' },
];

/**
 * Prefer live catalog scope options when available; else static STAT_SCOPE_OPTIONS.
 * @param {Array<{ code: string, name: string, flag: string, regionsLabel: string }> | null | undefined} catalogOptions
 */
export function resolveStatScopeOptions(catalogOptions) {
	return catalogOptions?.length ? catalogOptions : STAT_SCOPE_OPTIONS;
}

/**
 * @param {string} code
 * @param {Array<{ code: string, name: string, flag: string, regionsLabel: string }> | null | undefined} [options]
 * @returns {typeof STAT_SCOPE_OPTIONS[number]}
 */
export function getStatScopeOption(code, options) {
	const list = resolveStatScopeOptions(options);
	return list.find((opt) => opt.code === code) || list[0] || STAT_SCOPE_OPTIONS[0];
}

/** Map URL param values to stats scope (1:1 for game page). */
export function mapTypeToStatsScope(mapType) {
	if (mapType === 'CAN' || mapType === 'MX' || mapType === 'COMBINED') return mapType;
	return 'US';
}
